<template>
    <transition>
        <div v-if="show" class="modal-wrap" :class="{ display: show2 }">
            <div class="modal-backdrop"></div>
            <div class="modal">
                <div class="modal-inner">
                    <div class="modal-header">
                        {{ title }}
                    </div>
                    <div class="modal-body">
                        {{ content }}
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="modal-btn btn-close"
                            @click="close"
                            v-if="showCancel"
                        >
                            {{ cancelText ? cancelText : '取消' }}
                        </button>
                        <button type="button" class="modal-btn btn-confirm" @click="confirm">
                            {{ confirmText ? confirmText : '确定' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'modal',
    data() {
        return {
            title: '提示',
            content: '',

            show: false,
            show2: false,

            showCancel: true,
            cancelText: '取消',
            confirmText: '确定',

            promiseStatus: null,
        };
    },
    methods: {
        // 关闭按钮事件
        close() {
            this.show = false;
            this.show2 = false;

            this.promiseStatus && this.promiseStatus.resolve({ cancel: true });
            // console.log('点击了 取消');
        },

        // 确定按钮事件
        confirm() {
            this.show = false;
            this.show2 = false;

            this.promiseStatus && this.promiseStatus.resolve({ confirm: true });
            // console.log('点击了 确定');
        },
    },
};
</script>
<style scoped lang="scss">
@import '~@/stylesheets/modules/all';
%absolute {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

.modal-wrap {
    @extend %absolute;
    z-index: 2000;
    &.display {
        pointer-events: auto;
        .modal-backdrop {
            opacity: 1;
        }
        .modal {
            transform: translate(-50%, -50%) scale(1);
        }
    }
}
.modal-backdrop {
    @extend %absolute;
    z-index: 1;
    background: rgba(0, 0, 0, 0.62);
    opacity: 0;
    will-change: transform;
    transition: all 0.3s;
}

.modal {
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    width: 100%;
    max-width: 360px;
    transform: translate(-50%, -50%) scale(1.1);
    will-change: transform;
    transition: all 0.1s ease-in;
}

.modal-inner {
    margin: 12px;
    // background-color: white;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;
}
.modal-header {
    font-size: 17px;
    padding: 16px 24px;
    font-weight: 400;
}
.modal-body {
    padding: 0 24px 16px;
    min-height: 40px;
    font-size: 17px;
    line-height: 1.4;
    word-wrap: break-word;
    word-break: break-all;
    // color: rgba(0, 0, 0, 0.5);
}
.modal-footer {
    position: relative;
    line-height: 50px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    border-top: 1px solid rgba(127, 127, 127, 0.1);
}
.modal-btn {
    cursor: pointer;
    font-size: 17px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    color: #333;
    font-weight: 400;
    line-height: 50px;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    position: relative;
    border: none;
    outline: none;
    position: relative;

    &:active {
        background-color: rgba(127, 127, 127, 0.1);
    }
    &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 1px;
        background: rgba(127, 127, 127, 0.1);
    }
    &:first-child {
        &:after {
            display: none;
        }
    }
}
.btn-close {
    color: #333;
    background-color: transparent;
}
.btn-confirm {
    color: #00b4f8;
    background-color: transparent;
}

//
// .modal-inner {
//     background-color: $LightPrimarySystemBackground;
//     color: $LightPrimaryLabelColor;
// }
// .modal-body {
//     color: $LightSecondaryLabelColor;
// }
// .btn-close {
//     color: $LightSecondaryLabelColor;
// }
// @media screen and (prefers-color-scheme: dark) {
//     .modal-inner {
//         background-color: $ElevatedTertiarySystemGroupedBackground;
//         color: $DarkPrimaryLabelColor;
//     }
//     .modal-body {
//         color: $DarkSecondaryLabelColor;
//     }
//     .btn-close {
//         color: $DarkSecondaryLabelColor;
//     }
// }
</style>
